import React from 'react';
import { CURRENT_SITE } from '../../../config-sites';
import './TitleAndText.scss';

export interface TitleAndTextContentInputs {
    title?: string;
    body?: string;
    isArticle?: boolean;
}

export const TitleAndText = ({
    inputs,
}: {
    inputs: TitleAndTextContentInputs;
}) => {
    if (inputs.body) {
        inputs.body = inputs.body.replaceAll(
            `/sites/default/files`,
            `${CURRENT_SITE.endpoint}/sites/default/files`
        );
    }
    if (!inputs.title && !inputs.body) {
        return null;
    }
    if (inputs.isArticle) {
        return (
            <section className="paragraph__text_title article">
                {inputs.title && (
                    <h2 className="typestack-title-4">{inputs.title}</h2>
                )}
                {inputs.body && (
                    <div
                        className="typestack-body-2 body"
                        dangerouslySetInnerHTML={{ __html: inputs.body }}
                    />
                )}
            </section>
        );
    }
    return (
        <section className="kite-container paragraph__text_title">
            {inputs.title && (
                <h2 className="typestack-title-4">{inputs.title}</h2>
            )}
            {inputs.body && (
                <div
                    className="typestack-body-2 body"
                    dangerouslySetInnerHTML={{ __html: inputs.body }}
                />
            )}
        </section>
    );
};
